import { useEffect, useState } from 'react';
import { content } from './content';
function fill(template, vars) {
  return template.replace(/\{(\w+)\}/g, (_, k) => vars[k] ?? '');
}
function ThankYou({ submission }) {
  const t = content.thankYou;
  const [downloadUrl, setDownloadUrl] = useState(null);
  useEffect(() => {
    if (!submission?.pdfFile) return;
    const url = URL.createObjectURL(submission.pdfFile);
    setDownloadUrl(url);
    return () => URL.revokeObjectURL(url);
  }, [submission?.pdfFile]);
  const approved = submission.consentChoice === 'opt_in';
  const vars = {
    patient: `${submission.patient.firstName} ${submission.patient.lastName}`.trim(),
    facility: submission.facility.name,
  };
  return (
    <div className="tcf-thankyou" role="status" aria-live="polite">
      <h3 className="tcf-thankyou-title">{approved ? t.approvedHeading : t.declinedHeading}</h3>
      <p>{fill(approved ? t.approvedIntro : t.declinedIntro, vars)}</p>
      {approved && (
          <>
            <p>{t.approvedBody}</p>

            {/*
        <p className="tcf-thankyou-subhead">
            {t.nextStepsHeading}
        </p>
        <ul>
            {t.nextSteps.map((s) => (
                <li key={s}>{s}</li>
            ))}
        </ul>
        */}
          </>
      )}
      {downloadUrl && (
        <a
          className="tcf-submit tcf-thankyou-download"
          href={downloadUrl}
          download={submission.pdfFile.name || 'Informed-Consent.pdf'}
        >
          Download signed consent PDF
        </a>
      )}
      <p>
        {t.questions}
        <a href={`mailto:${t.email}`}>{t.email}</a>
        {t.orCall}
        <a href={t.phoneHref}>{t.phone}</a>
      </p>
    </div>
  );
}
export { ThankYou };
